import React from 'react'

import { useLocation } from '@reach/router'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
// import Helmet from 'react-helmet'

import ThirdPartyScripts from 'src/components/partials/ThirdPartyScripts'

function SEO({
  description,
  image,
  lang = 'en',
  meta,
  noImage,
  robots,
  title,
  loadThirdPartyScripts = true,
  children
}: {
  description?: string
  image?: string
  lang?: string
  meta?: string
  noImage?: boolean
  robots?: string
  title?: string
  loadThirdPartyScripts?: boolean
  children?: React.ReactNode
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
            socialTitle
            socialDescription
          }
        }
      }
    `
  )
  const location = useLocation()
  const url = `https://flatfile.com${location.pathname}`
  const metaDescription = description || site.siteMetadata.description
  const socialTitle = title || site.siteMetadata.socialTitle
  const socialDescription = description || site.siteMetadata.socialDescription
  let metaImage =
    image ||
    `https://flatfile.com/img/og/flatfile-ai-powered-data-migration-platform-og-img4.png`
  if (metaImage.substring(0, 2) === '//') {
    metaImage = 'https://' + metaImage.slice(2)
  }
  return (
    <>
      <html lang={lang} />
      {/* General tags */}
      <title>{socialTitle} | Flatfile</title>
      <meta content={metaDescription} name='description' />
      {robots === 'hide' && <meta content='noindex, nofollow' name='robots' />}
      {!noImage && <meta content={metaImage} name='image' />}
      {/* OpenGraph tags */}
      <meta content={url} property='og:url' />
      <meta content='summary_large_image' name='twitter:card' />
      <meta content={site.siteMetadata.author} name='twitter:creator' />
      <meta content={socialTitle} property='og:title' />
      <meta content={socialDescription} property='og:description' />
      {!noImage && <meta content={metaImage} property='og:image' />}

      {loadThirdPartyScripts && <ThirdPartyScripts />}

      {children}
    </>
  )
}

SEO.defaultProps = {
  description: ``,
  lang: `en`,
  meta: []
}

SEO.propTypes = {
  description: PropTypes.string,
  image: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
}

export default SEO
